import OperatorApplicationDialogHistoryExposeInterface
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogHistoryExposeInterface";

export interface DialogChatAreaExposeInterface {
    selectedMessagesToText: () => string,
    history: OperatorApplicationDialogHistoryExposeInterface,
    getSelectedMessages: () => OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]
}

export const SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME = "scrollToClientMessageById";

export interface ScrollToClientMessageByIdPayloadInterface {
    username: string,
    messageId: number
}

export const AUDIO_MESSAGE_EVENT = "operatorApplicationAudioMessageEvent";

export interface AudioMessageEventPayloadInterface {
    key: string,
    play: boolean,
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel,
    audio: HTMLAudioElement
}